import { cyber as viemCyber } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const cyber = {
  displayName: 'Cyber',
  runtime: 'evm',
  viemChain: viemCyber,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'cyber' },
    qnStreams: {
      networkKey: 'cyber-mainnet',
    },
    pimlico: { chainSlug: 'cyber-mainnet' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
